import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Navegation = () => {
    return (
        <div>
            <Navbar bg="light" expand="lg">
  <Container>
    <Navbar.Brand href="#home">My Shoes Shop</Navbar.Brand>
    <Navbar.Toggle aria-controls="basic-navbar-nav" />
    <Navbar.Collapse id="basic-navbar-nav">
      <Nav className="mx-auto fw-bold">
        <Nav.Link   as= {Link} to="/">Home</Nav.Link>
        <Nav.Link   as= {Link} to="/review">Review</Nav.Link>
        <Nav.Link   as= {Link} to="/dashboard">Dashboard</Nav.Link>
        <Nav.Link   as= {Link} to="/blog">Blog</Nav.Link>
      </Nav>
    </Navbar.Collapse>
  </Container>
</Navbar>
        </div>
    );
};

export default Navegation;